
import OverviewAgentPage from './OverviewAgentPage';
import OverviewPage from './OverviewPage';

const OverviewMainPage = () => {
  const getRole = localStorage.getItem("IbaRole");
  console.log(getRole, "getRoleIBA");
  

  return (
    <>
      {getRole === "IBA Admin" ?
        <div>
          <OverviewPage />
        </div>
        : getRole === "IBA" &&
        <div>
          <OverviewAgentPage />
        </div>
      }
    </>
  );
};

export default OverviewMainPage;
